export function scrollIntoView (elementId: string): void {
  if (elementId !== '') {
    const element = document.getElementById(elementId)
    if (element != null) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }
}
